/**
 * Portal Manta · KbRag
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { KB_RAG_MOCK_RESPOSTA, KB_RAG_SUGESTOES } from '../../app-globals.js';

function KbRag(){
  const [query,setQuery]=useState('');
  const [result,setResult]=useState(null);
  const [loading,setLoading]=useState(false);
  const runQuery=(q)=>{
    setLoading(true);
    setTimeout(()=>{
      setResult(KB_RAG_MOCK_RESPOSTA);
      setLoading(false);
    },700);
  };
  return(<div style={{padding:'12px 16px'}}>
    <div style={{marginBottom:12}}>
      <div style={{fontSize:12.5,fontWeight:700,color:V.br2}}>Busca RAG — Pergunta & Resposta com Citações</div>
      <div style={{fontSize:10.5,color:V.g5,marginTop:2}}>Consulta semântica sobre 15 documentos indexados · resposta gerada com citação das fontes</div>
    </div>
    {/* Campo de busca */}
    <div style={{display:'flex',gap:8,marginBottom:14}}>
      <input
        type="text"
        value={query}
        onChange={e=>setQuery(e.target.value)}
        placeholder="Faça uma pergunta sobre orçamento, CUs, BDI, tipologias, normas..."
        style={{flex:1,padding:'10px 14px',border:`1px solid ${V.g2}`,borderRadius:8,fontSize:11.5,fontFamily:'inherit',background:'#fff',color:V.g7,outline:'none'}}
        onKeyDown={e=>{if(e.key==='Enter'&&query.trim()) runQuery(query);}}
      />
      <button onClick={()=>query.trim()&&runQuery(query)} disabled={loading||!query.trim()} style={{padding:'10px 18px',background:V.or,color:'#fff',border:'none',borderRadius:8,fontSize:11.5,fontWeight:700,cursor:loading||!query.trim()?'not-allowed':'pointer',opacity:loading||!query.trim()?.5:1,fontFamily:'inherit'}}>
        {loading?'Consultando...':'Buscar'}
      </button>
    </div>
    {/* Sugestões */}
    {!result&&!loading&&<div>
      <div style={{fontSize:10,fontWeight:700,color:V.g5,textTransform:'uppercase',letterSpacing:'.08em',marginBottom:8}}>Perguntas sugeridas</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))',gap:8}}>
        {KB_RAG_SUGESTOES.map((s,i)=>(<div key={i} onClick={()=>{setQuery(s.q);runQuery(s.q);}} style={{padding:'10px 12px',background:'#fff',border:`1px solid ${V.g2}`,borderRadius:8,cursor:'pointer',transition:'all .12s'}}
        onMouseEnter={e=>{e.currentTarget.style.borderColor=V.or;e.currentTarget.style.background=V.orp;}}
        onMouseLeave={e=>{e.currentTarget.style.borderColor=V.g2;e.currentTarget.style.background='#fff';}}
        >
          <div style={{fontSize:10.5,color:V.br,fontWeight:600,marginBottom:4}}>{s.q}</div>
          <div style={{display:'flex',gap:3}}>{s.tags.map(t=>(<span key={t} style={{fontSize:8.5,color:V.g5,background:V.g1,padding:'1px 5px',borderRadius:3}}>{t}</span>))}</div>
        </div>))}
      </div>
    </div>}
    {/* Loading */}
    {loading&&<div style={{padding:24,textAlign:'center',color:V.g5,fontSize:11}}>
      <div style={{display:'inline-block',width:18,height:18,border:`2px solid ${V.g2}`,borderTopColor:V.or,borderRadius:'50%',animation:'spin 1s linear infinite'}}></div>
      <div style={{marginTop:8}}>Buscando em 15 documentos · gerando resposta...</div>
    </div>}
    {/* Resultado */}
    {result&&!loading&&<div style={{marginTop:4}}>
      <div style={{background:'#fff',border:`1px solid ${V.g2}`,borderRadius:10,padding:'14px 16px',marginBottom:10}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
          <span style={{fontSize:10,fontWeight:700,color:V.or,textTransform:'uppercase',letterSpacing:'.08em'}}>Resposta</span>
          <span style={{fontSize:9.5,color:V.g5,background:V.gnb,padding:'2px 7px',borderRadius:10,fontWeight:600}}>Confiança: {Math.round(result.confianca*100)}%</span>
        </div>
        <div style={{fontSize:11.5,color:V.g7,lineHeight:1.65}}>{result.resposta}</div>
      </div>
      <div style={{fontSize:10,fontWeight:700,color:V.g5,textTransform:'uppercase',letterSpacing:'.08em',marginBottom:6}}>Fontes citadas</div>
      {result.fontes.map((f,i)=>(<div key={i} style={{background:'#fff',border:`1px solid ${V.g2}`,borderRadius:8,padding:'9px 12px',marginBottom:5,borderLeft:`3px solid ${V.or}`}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
          <span style={{fontSize:9,fontWeight:700,color:V.or,fontFamily:'monospace'}}>{f.doc}</span>
          <span style={{fontSize:10.5,fontWeight:600,color:V.br}}>{f.label}</span>
        </div>
        <div style={{fontSize:10,color:V.g5,fontStyle:'italic',lineHeight:1.5}}>“{f.trecho}”</div>
      </div>))}
      <button onClick={()=>{setResult(null);setQuery('');}} style={{marginTop:10,padding:'6px 12px',background:'transparent',border:`1px solid ${V.g2}`,borderRadius:6,fontSize:10,color:V.g5,cursor:'pointer',fontFamily:'inherit'}}>← Nova busca</button>
    </div>}
    <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}`}</style>
  </div>);
}

export { KbRag };
export default KbRag;
